import * as React from 'react';

const SvgSearch = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    className={props.className}
  >
    <path
      d='M15.8614 14.2798L14.2715 15.8719L19.9547 21.5471L21.5446 19.955L15.8614 14.2798Z'
      fill='#695f5f'
    />
    <path
      d='M9.5 18.5C4.53333 18.5 0.5 14.4667 0.5 9.5C0.5 4.53333 4.53333 0.5 9.5 0.5C14.4667 0.5 18.5 4.53333 18.5 9.5C18.5 11.9917 17.3417 14.4 15.0667 16.6583L13.4833 15.0583C15.325 13.2333 16.25 11.3667 16.25 9.5C16.25 5.775 13.225 2.75 9.5 2.75C5.775 2.75 2.75 5.775 2.75 9.5C2.75 13.225 5.775 16.25 9.5 16.25C10.2667 16.25 11.0292 16.1192 11.7475 15.8667C12.005 15.7767 12.2567 15.6708 12.5 15.55V17.9833C11.5417 18.325 10.525 18.5 9.5 18.5Z'
      fill='#695f5f'
    />
  </svg>
);

export default SvgSearch;
